import { Box, Grid } from '@mui/material';
import DateChip from 'src/components/DateChip';
import PaperPanelInfo from 'src/components/PaperPanelInfo';
import Subtitle from 'src/components/Subtitle';
import { DebentureAssetData } from 'src/types/operations/debentures';

import { formatCompetence } from '../utils';

type AssetPrepaymentsProps = {
  data?: DebentureAssetData;
  isLoading?: boolean;
};

export default function AssetPrepayments({
  data,
  isLoading,
}: AssetPrepaymentsProps) {
  const prepayment = data?.prepayment;

  return (
    <>
      <Subtitle title="Pré-pagamentos no Período" />
      <Box display="flex" justifyContent="flex-end" alignItems="center" mb={1}>
        <DateChip
          title="Competência"
          date={formatCompetence(data?.dataReferencia)}
        />
      </Box>
      <Grid container spacing={2} sx={{ mb: 4 }}>
        <Grid item xs={12} md={4}>
          <PaperPanelInfo
            numeric
            title="Montante Pré-pago no mês"
            value={prepayment?.montante ?? undefined}
            loading={isLoading}
          />
        </Grid>
        <Grid item xs={12} md={8}>
          <PaperPanelInfo
            first
            title="Impactos"
            value={prepayment?.impacto ?? undefined}
            loading={isLoading}
          />
        </Grid>
      </Grid>
    </>
  );
}
